import React from 'react';
import styled from 'styled-components';
import { Colors } from '@inplayer-org/inplayer-ui';

// utils
import formatNumber from 'utils/formatNumber';

interface Props {
  totalItems?: number;
  // these are sent by Tooltip component
  active?: boolean;
  payload?: any;
}

const Tooltip = styled.div`
  padding: 5px;
  background-color: ${Colors.lightGray};
`;

const CustomTooltip: React.FunctionComponent<Props> = ({ active, payload, totalItems }) => {
  let percent = 0;
  if (totalItems && active) {
    percent = (payload[0].value / totalItems) * 100;
  }
  return active ? (
    <Tooltip>
      {payload &&
        `${(payload[0].payload.key || payload[0].payload.country || 'N/A').toUpperCase()} : ${formatNumber(
          payload[0].value
        )}`}
      &nbsp;
      {totalItems && `(${percent < 0.01 ? '<0.01' : percent.toFixed(2)}%)`}
    </Tooltip>
  ) : null;
};

export default CustomTooltip;
